"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const createSvgIcon_1 = __importDefault(require("../utils/createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("g", null,
    react_1.default.createElement("path", { fillRule: "evenodd", d: "m12 18.6617-6.4656 3.2375 1.081-7.1496-5.077-5.1488L8.672 8.4196 12 2l3.3279 6.4196 7.1337 1.1812-5.077 5.1488 1.081 7.1496L12 18.6617Z", clipRule: "evenodd" })), 'StarSolidIcon');
